const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

export const columns_feetype = [
    {
        dataField: 'description',
        text: 'Fee Type Name',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'itemType',
        text: 'Type',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'netsuiteItem',
        text: 'Corp Netsuite Item',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'netsuiteNonCorpItem',
        text: 'NonCorp Netsuite Item',
        sort: true,
        headerStyle: headerStyle
    }
];

export const sorting_feetype = [{
    dataField: 'description',
    order: 'asc'
}];